// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgResend24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g id="Communication/Resend">
					<path
						id="Union"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M6.39226 4.2002C5.04341 4.2002 3.94995 5.29365 3.94995 6.6425V11.4502H5.44995V6.6425C5.44995 6.37794 5.55898 6.13884 5.73456 5.96769L12.6999 11.938L19.6653 5.96768C19.8409 6.13884 19.95 6.37794 19.95 6.6425V16.2579C19.95 16.7783 19.5281 17.2002 19.0076 17.2002H10.2V18.7002H19.0076C20.3565 18.7002 21.45 17.6067 21.45 16.2579V6.6425C21.45 5.29365 20.3565 4.2002 19.0076 4.2002H6.39226ZM7.72737 5.7002L12.6999 9.9624L17.6725 5.7002H7.72737ZM4.69995 15.9428C4.0096 15.9428 3.44995 16.5025 3.44995 17.1928V19.6928H1.94995V17.1928C1.94995 15.674 3.18117 14.4428 4.69995 14.4428H7.63191L5.66963 12.4805L6.73029 11.4199L10.3819 15.0715L6.73029 18.7231L5.66963 17.6625L7.38929 15.9428H4.69995Z"
					/>
				</g>
			</Svg>
		);
	}
);
SvgResend24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgResend24;
